import { ApiError } from "src/interfaces/api-error";

export const isTooManyRequestsError = (error: unknown) => {
  return (error as ApiError).status === 429;
};
